import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import { throttle } from 'lodash';
import api from '@/api';
var doFetch = throttle( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var state, commit, names, dictsData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, commit = _ref.commit;
            names = Array.from(new Set(state.fetchList));
            commit('fetchListClean');
            _context.next = 5;
            return Promise.all(names.map(function (name) {
              return api.DICTDATA_ALL({
                page_size: 9999,
                dict_type: name
              });
            }));

          case 5:
            dictsData = _context.sent;
            dictsData.forEach(function (dictDataSource, dictDataIndex) {
              var dictName = names[dictDataIndex];
              var dictData = [];

              if (dictDataSource.list.length > 0) {
                dictData = dictDataSource.list.map(function (e) {
                  return {
                    label: e.dict_label,
                    value: e[dictDataSource.list[0].dict_value === '' ? 'dict_number' : 'dict_value'],
                    css_class: e.css_class,
                    list_class: e.list_class
                  };
                });
              }

              commit('set', {
                name: dictName,
                value: dictData
              });
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}(), 1000, {
  leading: false
});
export default (function (context) {
  return {
    namespaced: true,
    state: {
      // 字典数据
      dicts: [],
      // 请求队列
      fetchList: []
    },
    actions: {
      /**
       * @description 获取字典
       * @param {Object} vuex context
       * @param {String} name 字典名称
       */
      get: function get(_ref3, name) {
        var state = _ref3.state;
        var dict = state.dicts.find(function (e) {
          return e.name === name;
        });
        return dict && dict.value || [];
      },

      /**
       * @description 加载一个字典
       * @param {Object} vuex context
       * @param {String} name 字典名称
       */
      fetch: function fetch(payload) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        payload.commit('fetchListPush', name);
        doFetch(payload);
      }
    },
    mutations: {
      /**
       * @description 设置字典
       * @param {Object} vuex context
       * @param {Object} payload {String} name 字典名称
       * @param {Object} payload {Array} value 字典数据
       */
      set: function set(state) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref4$name = _ref4.name,
            name = _ref4$name === void 0 ? '' : _ref4$name,
            _ref4$value = _ref4.value,
            value = _ref4$value === void 0 ? [] : _ref4$value;

        var dictIndex = state.dicts.findIndex(function (e) {
          return e.name === name;
        });

        if (dictIndex < 0) {
          state.dicts.push({
            name: name,
            value: value
          });
        } else {
          state.dicts.splice(dictIndex, 1, {
            name: name,
            value: value
          });
        }
      },
      fetchListPush: function fetchListPush(state, item) {
        state.fetchList.push(item);
      },
      fetchListClean: function fetchListClean(state) {
        state.fetchList = [];
      }
    }
  };
});